export default __webpack_public_path__ + "static/media/votelogo.8c5e81f6.jpg";